
    // 类型定义
    interface DataItem {
        id: string;
        video: string;
        cover: string;
        icon: string;
        title: {
            text: string;
            sub: string;
        };
        beforeDesc?: string;
        needChangeStyle: boolean;
    }

    interface IconItem {
        icon: string;
        text: string;
    }

    import { getCurrentInstance, onMounted, onUnmounted, reactive, ref, nextTick, computed } from 'vue';
    import { setRem } from '~/utils/mobile';
    import { currentClipFlyHost, getBrowser, openInFotorAppByAdjustLink, downloadAppFunc, createAdjustDeepLink, openInClipFlyAppByAdjustLink } from '~/utils/common';
    import { throttle } from 'throttle-debounce';
    import { usePageScroll } from '~/hooks/usePageScroll';

    // 常量定义
    const CONSTANTS = {
        THROTTLE_DELAY: 1000,
        DOWNLOAD_URL: 'https://sc4p.adj.st?adj_t=1qtlvds5_1qfelzcx'
    } as const;

    export default {
        layout: "fotor-default",
        // SEO和分享信息配置
        head() {
            return {
                title: 'Clipfly - AI Video Generator',
                link: [
                    // hid 需要与 nuxt.config.js 中的一致才能覆盖
                    { rel: "icon", type: "image/png", href: "/clipflyStatic/clipfly_icon.png", hid: "favicon" },
                ],
                meta: [
                    { name: 'description', content: 'Clipfly - AI Video Generator'},
                    { name: "robots", content: "noindex,nofollow" },
                    { name: "googlebot", content: "noindex,nofollow" },
                    { name: "canonical", content: "https://www.clipfly.ai/video-ai/ai-video-generator/" },
                ]
            };
        },

        setup() {
            const { proxy: vm } = getCurrentInstance()! as any;
            const pageData = reactive(vm.$t("downloadApp"));
            // 页面滚动状态

            const containerRef = ref<HTMLElement | null>(null);

            // 监听downloadPage容器的滚动
            const scrollDistance = usePageScroll(containerRef);

            // 响应式数据
            const should_showFixBox = ref(false);
            const dataList = ref<DataItem[]>([]);
            const iconList = ref<IconItem[]>([]);




            // 初始化数据列表
            const initDataList = () => {
                dataList.value = [
                    {
                        id: '1',
                        cover: "https://dl.haozhaopian.net/download/clipfly/ai_video.jpg",
                        video: "https://dl.haozhaopian.net/download/clipfly/ai_video.mp4",


                        icon: require('~/assets/images/downloadApp/ic_discover_generate.svg'),
                        needChangeStyle: true,
                        title: {
                            text: 'AI VIDEO',
                            sub: 'GENERATOR',
                        },
                    },
                    {
                        id: "2",
                        cover: "https://dl.haozhaopian.net/download/clipfly/story.jpg",
                        video: "https://dl.haozhaopian.net/download/clipfly/story.mp4",
                        icon: require('~/assets/images/downloadApp/ic_discover_communty.svg'),
                        needChangeStyle: false,
                        title: {
                            text: 'FACE TO',
                            sub: 'FILM STAR',
                        },
                    },
                    {
                        id: "3",
                        cover: "https://dl.haozhaopian.net/download/clipfly/meme.jpg",
                        video: "https://dl.haozhaopian.net/download/clipfly/meme.mp4",
                        icon: require('~/assets/images/downloadApp/ic_discover_challenge.svg'),
                        needChangeStyle: false,
                        title: {
                            text: 'FROM PROMPT TO',
                            sub: 'MASTERPIECE',
                        },

                    },
                    {
                        id: "4",
                        cover: "https://dl.haozhaopian.net/download/clipfly/imgToVideo.jpg",
                        video: "https://dl.haozhaopian.net/download/clipfly/imgToVideo.mp4",
                        icon: require('~/assets/images/downloadApp/ic_discover_challenge.svg'),
                        needChangeStyle: true,
                        title: {
                            text: 'START',
                            sub: 'FROM ANY IDEA',
                        },

                    },
                    {
                        id: "5",
                        cover: "https://dl.haozhaopian.net/download/clipfly/more.jpg",
                        video: "https://dl.haozhaopian.net/download/clipfly/more.mp4",
                        icon: require('~/assets/images/downloadApp/ic_discover_challenge.svg'),
                        needChangeStyle: false,
                        title: {
                            text: 'RICH VIDEO ',
                            sub: 'TEMPLATES',
                        },
                    }
                ];
            };

            // 初始化图标列表
            const initIconList = () => {
                iconList.value = [
                    {
                        icon: require('~/assets/clipfly/svg/ic-1.svg'),
                        text: 'Reference to Video'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-2.svg'),
                        text: 'Image to Video'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-3.svg'),
                        text: 'Text to Image to Video'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-4.svg'),
                        text: 'Text to Video'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-5.svg'),
                        text: 'AI Meme Generator'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-6.svg'),
                        text: 'AI Remover'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-7.svg'),
                        text: 'First and last frame'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-8.svg'),
                        text: 'Video to Video'
                    },
                    {
                        icon: require('~/assets/clipfly/svg/ic-9.svg'),
                        text: 'Video to Continues'
                    }
                ];
            };



            // 计算属性：是否为iOS设备
            const isIOSDevice = computed(() => getBrowser().isiOS);

            // 计算属性：是否为Android设备
            const isAndroidDevice = computed(() => getBrowser().isAndroid);

            // 下载应用处理函数（节流防抖）
            const goDownloadApp = throttle(CONSTANTS.THROTTLE_DELAY, true, function() {
                // 使用更安全的跳转方式
                window.location.href = CONSTANTS.DOWNLOAD_URL;
            });
            //是否进入页面就自动打开 app store
            const autoOpenAppStore = () => {
                // console.log("autoOpenAppStore", this.$route.query.app_store, this.browser.isiOS)
                // 参数中有 app_store 则自动触发点击下载按钮
                if (!vm.$route.query.app_store) {
                    return;
                }
                const id = setTimeout(() => {
                    downloadApp()
                }, 200);

                document.addEventListener(
                    "visibilitychange",
                    function run() {
                        document.removeEventListener("visibilitychange", run);
                        clearTimeout(id);
                        console.log('clearTimeout');
                    },
                );
            }

            const downloadApp = () => {
                //当路径中有 store_link 参数时，使用该参数作为应用商店链接打开【一般用于打开schema时的中间页使用指定的追踪链接作为下载链接】
                let store_link = vm.$route.query.store_link;
                if (store_link) {
                    location.href = store_link;
                }
                //如果是由桌面网页支付成功后扫码进来的，单独使用一个 adjust 链接【app新装后需要知道是由网页支付成功扫码后点击的下载】
                //链接格式如下：https://mobile.fotor.com/?utm_source=fotor-web&utm_content=upgrade_success_window&utm_campaign=web_to_app&_channel_track_key=6GCussC2
                else if (
                    vm.$route.query.utm_source && "utm_source" ||
                    vm.$route.query.utm_content && "upgrade_success_window" ||
                    vm.$route.query.utm_campaign && "web_to_app"
                ) {
                    const schema = "clipfly://" + location.search;
                    openInClipFlyAppByAdjustLink({
                        campaign: "web_to_app",
                        adgroup: "upgrade_success_window",
                        schema: schema,
                        urlType: "download_app"
                    });
                } else {
                    downloadAppFunc("", false, encodeURIComponent(vm.$route.query.referrer), "clipfly");
                }
            }

            // 是否进入页面就自动打开 app store
            // 使用 intersection observer 观察下载按钮
            let observer: IntersectionObserver | null = null; // 添加类型注解
            onMounted(() => {
                if (process.client) {
                    try {
                        // 初始化数据
                        initDataList();
                        initIconList();
                        autoOpenAppStore();
                        // 初始化设置
                        setRem(document, window, 375);

                        // 等待下一帧确保DOM已渲染完成
                        nextTick(() => {
                            // 创建 Intersection Observer，指定root为downloadPage容器
                            observer = new IntersectionObserver(
                                (entries) => {
                                    // 当下载按钮不可见时,显示固定按钮
                                    should_showFixBox.value = !entries[0].isIntersecting;
                                },
                                {
                                    root: containerRef.value, // 指定观察的根容器
                                    threshold: 0, // 当元素完全不可见时触发
                                    rootMargin: '0px' // 可以根据需要调整这个值
                                }
                            );

                            // 获取下载按钮元素并开始观察
                            const downloadBtn = document.getElementById('downLoadBtnBox');
                            if (downloadBtn) {
                                observer.observe(downloadBtn);
                            }
                        });
                    } catch (error) {
                        console.error('组件初始化失败:', error);
                    }

                    const height = window.innerHeight;
                    const bgElement = document.querySelector('.bg') as HTMLElement;
                    if (bgElement) {
                        if (isIOSDevice.value) {
                            bgElement.style.height = height >= 932 ? '80rem' : '78rem';
                        } else {
                            bgElement.style.height = height >= 932 ? '80rem' : '78rem';
                        }
                    }
                }
            });

            onUnmounted(() => {
                if (observer) {
                    observer.disconnect(); // 清理 observer
                    observer = null;
                }
            });

            return {
                containerRef,
                should_showFixBox,
                scrollDistance,
                dataList,
                iconList,
                pageData,
                goDownloadApp,
                isIOSDevice,
                isAndroidDevice,
                autoOpenAppStore
            };
        }
    };
